/**
 * B4 (akış araştırması): girişsiz ziyaretçi 👏'a basınca giriş sayfasına gider; giriş sonrası aynı
 * kart açılır ve tebrik bir kez kaydedilir. Niyet yalnız bu sekmede (sessionStorage) ve 30 dakika
 * tutulur: bağlantıya eklenmez, başkasının paylaştığı bağlantı kendiliğinden tebrik ettiremez.
 */
const KEY = 'tenis.feed.congratsIntent';
const MAX_AGE_MS = 30 * 60 * 1000;

type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
const session = (): Store | null => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export function rememberCongratsIntent(eventId: string, store = session(), now = Date.now()): void {
  try {
    store?.setItem(KEY, JSON.stringify({ id: eventId, at: now }));
  } catch {
    // Depolama kapalı: giriş sonrası kullanıcı karta kendisi tebrik eder.
  }
}

/** Geçerli niyetin kart kimliği; süresi geçmiş ya da bozuk kayıt silinir. */
export function pendingCongratsIntent(store = session(), now = Date.now()): string | null {
  try {
    const value = JSON.parse(store?.getItem(KEY) || 'null');
    if (
      value &&
      typeof value.id === 'string' &&
      typeof value.at === 'number' &&
      now - value.at < MAX_AGE_MS
    )
      return value.id;
    store?.removeItem(KEY);
  } catch {
    // yok say
  }
  return null;
}

export function clearCongratsIntent(store = session()): void {
  try {
    store?.removeItem(KEY);
  } catch {
    // yok say
  }
}
